module.exports = __webpack_public_path__ + "img/gj_logo_web.2550be08.png";